import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
const PROVINCES = ['Alberta', 'British Columbia', 'Manitoba', 'New Brunswick', 'Newfoundland and Labrador', 'Nova Scotia', 'Ontario', 'Prince Edward Island', 'Quebec', 'Saskatchewan', 'Northwest Territories', 'Nunavut', 'Yukon'];
export function ProfilePage() {
  const navigate = useNavigate();
  const {
    profile,
    updateProfile
  } = useAuth();
  const [formData, setFormData] = useState({
    province: profile?.province || '',
    completingFor: profile?.completingFor || '',
    children: profile?.children || '',
    property: profile?.property || '',
    previousCheck: profile?.previousCheck || ''
  });
  const handleNext = () => {
    updateProfile(formData);
    navigate('/onboarding/preferences');
  };
  const handleBack = () => {
    navigate('/onboarding/welcome');
  };
  const isValid = formData.province && formData.completingFor;
  return <div className="min-h-screen bg-aliceBlue flex flex-col justify-center py-12 sm:px-6 lg:px-8" data-id="element-1353">
      <div className="sm:mx-auto sm:w-full sm:max-w-xl" data-id="element-1354">
        <div className="mb-8" data-id="element-1355">
          <div className="flex justify-between items-center mb-2" data-id="element-1356">
            <span className="text-sm font-semibold text-primary" data-id="element-1357">
              Personal Profile
            </span>
            <span className="text-sm font-medium text-secondary" data-id="element-1358">Step 1</span>
          </div>
          <div className="w-full bg-borderColor rounded-full h-2" data-id="element-1359">
            <div className="bg-violetBlue h-2 rounded-full transition-all duration-300" style={{
            width: '25%'
          }} data-id="element-1360"></div>
          </div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="bg-white py-8 px-6 shadow-sm sm:rounded-xl sm:px-10 border border-borderColor" data-id="element-1361">
          <div className="space-y-8" data-id="element-1362">
            <div data-id="element-1363">
              <label className="block text-sm font-medium text-primary mb-2" data-id="element-1364">
                Province of Residence
              </label>
              <select value={formData.province} onChange={e => setFormData({
              ...formData,
              province: e.target.value
            })} className="w-full px-4 py-3 rounded-lg border border-borderColor focus:ring-2 focus:ring-violetBlue focus:border-violetBlue outline-none bg-white" data-id="element-1365">
                <option value="" data-id="element-1366">Select a province</option>
                {PROVINCES.map(p => <option key={p} value={p} data-id="element-1367">
                    {p}
                  </option>)}
              </select>
            </div>

            <div data-id="element-1368">
              <label className="block text-sm font-medium text-primary mb-2" data-id="element-1369">
                Who are you completing this for?
              </label>
              <div className="flex flex-col gap-3" data-id="element-1370">
                {[{
                id: 'myself',
                label: 'Just myself'
              }, {
                id: 'household',
                label: 'My household'
              }, {
                id: 'both',
                label: 'Personal and business needs'
              }].map(option => <button key={option.id} onClick={() => setFormData({
                ...formData,
                completingFor: option.id
              })} className={`w-full text-left py-3 px-4 rounded-lg border ${formData.completingFor === option.id ? 'border-violetBlue bg-aliceBlue text-violetBlue font-semibold' : 'border-borderColor text-primary hover:bg-aliceBlue'} transition-colors`} data-id="element-1371">
                    {option.label}
                  </button>)}
              </div>
            </div>

            <div data-id="element-1372">
              <label className="block text-sm font-medium text-primary mb-2" data-id="element-1373">
                Do you have children or dependants?
              </label>
              <div className="flex gap-4" data-id="element-1374">
                {['Yes', 'No'].map(option => <button key={option} onClick={() => setFormData({
                ...formData,
                children: option
              })} className={`flex-1 py-3 px-4 rounded-lg border ${formData.children === option ? 'border-violetBlue bg-aliceBlue text-violetBlue font-semibold' : 'border-borderColor text-primary hover:bg-aliceBlue'} transition-colors`} data-id="element-1375">
                    {option}
                  </button>)}
              </div>
            </div>

            <div data-id="element-1376">
              <label className="block text-sm font-medium text-primary mb-2" data-id="element-1377">
                Do you own property?
              </label>
              <div className="flex gap-4" data-id="element-1378">
                {['Yes', 'No'].map(option => <button key={option} onClick={() => setFormData({
                ...formData,
                property: option
              })} className={`flex-1 py-3 px-4 rounded-lg border ${formData.property === option ? 'border-violetBlue bg-aliceBlue text-violetBlue font-semibold' : 'border-borderColor text-primary hover:bg-aliceBlue'} transition-colors`} data-id="element-1379">
                    {option}
                  </button>)}
              </div>
            </div>

            <div data-id="element-1380">
              <label className="block text-sm font-medium text-primary mb-2" data-id="element-1381">
                Have you completed a legal health check before?{' '}
                <span className="text-secondary font-normal" data-id="element-1382">(Optional)</span>
              </label>
              <div className="flex gap-4" data-id="element-1383">
                {['Yes', 'No'].map(option => <button key={option} onClick={() => setFormData({
                ...formData,
                previousCheck: option
              })} className={`flex-1 py-2 px-4 rounded-lg border ${formData.previousCheck === option ? 'border-violetBlue bg-aliceBlue text-violetBlue font-semibold' : 'border-borderColor text-primary hover:bg-aliceBlue'} transition-colors text-sm`} data-id="element-1384">
                    {option}
                  </button>)}
              </div>
            </div>
          </div>

          <div className="mt-10 flex justify-between gap-4" data-id="element-1385">
            <button onClick={handleBack} className="flex items-center px-6 py-3 border border-borderColor rounded-lg text-sm font-semibold text-primary hover:bg-aliceBlue transition-colors" data-id="element-1386">
              <ChevronLeft className="w-4 h-4 mr-1" data-id="element-1387" /> Back
            </button>
            <button onClick={handleNext} disabled={!isValid} className="flex items-center px-8 py-3 bg-violetBlue text-white rounded-lg text-sm font-semibold hover:opacity-90 disabled:opacity-50 disabled:cursor-not-allowed transition-opacity" data-id="element-1388">
              Next <ChevronRight className="w-4 h-4 ml-1" data-id="element-1389" />
            </button>
          </div>
        </motion.div>
      </div>
    </div>;
}